<template>
  <div>
    <div class="gradesCCs qcFrom" v-for="(item, objindex) in obj" :key="objindex">
      <div class="gradesCCsTop">
        <p class="gradesCCsTopL">
          {{ item.Description }}({{ item.TotalScore }})
          <i v-if="item.notSelected" class="iconfont iconjingshi1" style="color: #FCAE23;"></i>
        </p>
        <div class="gradesCCsTopR">
          <el-checkbox
            v-model="item.IsSerious"
            v-if="item.SeriousScore"
            :disabled="isSubmint"
            @change="compentedScore(item.IsSerious, objindex)"
          >
            严重
          </el-checkbox>
          <span style="margin-left:10px">
            扣分:{{ computeItemScore(item.Score, item.SeriousScore, item.IsSerious, objindex) }}
          </span>

          <a
            href="javascript:;"
            class="el-icon-caret-bottom gradesCCsTopRA"
            v-if="!item.IsNoteShow"
            @click="item.IsNoteShow = !item.IsNoteShow"
          ></a>
          <a
            href="javascript:;"
            class="el-icon-caret-top gradesCCsTopRA"
            v-else
            @click="item.IsNoteShow = !item.IsNoteShow"
          ></a>
        </div>
      </div>
      <!-- {{item.OptionGuid}} -->
      <!-- {{ item.IsSerious }} -->
      <el-checkbox-group
        v-if="item.OptionList && item.OptionList.length > 0"
        v-model="item.OptionGuid"
        @change="compentedScore"
        size="mini"
        :disabled="isSubmint || item.IsSerious"
        class="gradesSelest"
      >
        <!-- <el-checkbox v-for="(items,index) in item.OptionList" :key="items.Id" :label="items.OptionGuid" @change="checkboxClick(objindex,index,items)">
					<template v-if="items.Remark">
						{{items.Description}}({{items.Score}}) : {{items.Remark}}
					</template>
					<template v-else>
						{{items.Description}}({{items.Score}})
					</template>
				</el-checkbox> -->
        <el-checkbox-button
          class="btnMar"
          v-for="(items, index) in item.OptionList"
          :key="index"
          :label="items.OptionGuid"
          @change="checkboxClick(objindex, index, item)"
        >
          <template v-if="items.Remark">
            <el-tooltip :content="items.Remark" placement="top" popper-class="atooltip" effect="dark">
              <span>{{ items.Description }}({{ items.Score }})</span>
            </el-tooltip>
          </template>
          <template v-else>{{ items.Description }}({{ items.Score }})</template>
        </el-checkbox-button>
      </el-checkbox-group>

      <el-slider
        v-else
        v-model="item.Score"
        :max="item.TotalScore"
        @change="compentedScore"
        :disabled="isSubmint || item.IsSerious"
      ></el-slider>
      <div class="gradesSelest" v-if="item.IsNoteShow">
        <el-form ref="form">
          <el-form-item label="原因">
            <el-input
              :readonly="isSubmint"
              v-model="item.Note"
              type="textarea"
              @blur="noteBlur(item, objindex)"
              :class="item.notFilledIn ? 'bgImgSet' : ''"
              placeholder="请输入扣分原因"
            ></el-input>
            <!--<p v-else v-html="item.Note"></p>-->
          </el-form-item>
        </el-form>
      </div>
      <div class="dividingLine"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  props: {
    obj: {},
  },
  computed: {
    ...Vuex.mapState("doctor", ["doctorQCReportIndex", "isSubmint", "doctorQCImg", "doctorQCReport", "gradeType", "doctorQCHistory"]),
  },
  methods: {
    ...Vuex.mapMutations("doctor", ["setScoreTotile"]),
    checkboxClick(objindex, index, item) {
      this.$forceUpdate();
      this.$emit("changeActiveNames");
      if (this.gradeType == "report") {
        let totalScore = 0; // 重置总分
        let fatherTotalScore = this.doctorQCReport[objindex].TotalScore;
        this.doctorQCReport[objindex].OptionGuid.forEach((guid) => {
          const selectedItem = this.doctorQCReport[objindex].OptionList.find((item) => item.OptionGuid === guid);
          if (selectedItem) {
            totalScore += selectedItem.Score;
          }
        });
        if (totalScore >= fatherTotalScore) {
          totalScore = fatherTotalScore;
        }
        this.doctorQCReport[objindex].Score = totalScore;
        this.doctorQCReport[objindex].OptionGuid = item.OptionGuid;
        // this.doctorQCReport[objindex].OptionResult = item;
      }
      if (this.gradeType == "img") {
        let totalScore = 0; // 重置总分
        let fatherTotalScore = this.doctorQCImg[objindex].TotalScore;
        this.doctorQCImg[objindex].OptionGuid.forEach((guid) => {
          const selectedItem = this.doctorQCImg[objindex].OptionList.find((item) => item.OptionGuid === guid);
          if (selectedItem) {
            totalScore += selectedItem.Score;
          }
        });
        if (totalScore >= fatherTotalScore) {
          totalScore = fatherTotalScore;
        }
        this.doctorQCImg[objindex].Score = totalScore;
        this.doctorQCImg[objindex].OptionGuid = item.OptionGuid;
        // this.doctorQCImg[objindex].OptionResult = item;
      }
      console.log(objindex,item,'objindex,item');
      if (this.gradeType == "history") {
        let totalScore = 0; // 重置总分
        let fatherTotalScore = this.doctorQCHistory[objindex].TotalScore;
        this.doctorQCHistory[objindex].OptionGuid.forEach((guid) => {
          const selectedItem = this.doctorQCHistory[objindex].OptionList.find((item) => item.OptionGuid === guid);
          if (selectedItem) {
            totalScore += selectedItem.Score;
          }
        });
        if (totalScore >= fatherTotalScore) {
          totalScore = fatherTotalScore;
        }
        this.doctorQCHistory[objindex].Score = totalScore;
        this.doctorQCHistory[objindex].OptionGuid = item.OptionGuid;
      }
    },
    noteBlur(item, index) {
      if (this.gradeType == "report") {
        if (item.Note != "") {
          this.doctorQCReport[index].notFilledIn = false;
        } else {
          if (item.Score != 0) {
            this.doctorQCReport[index].notFilledIn = true;
          }
        }
      }
      if (this.gradeType == "img") {
        if (item.Note != "") {
          this.doctorQCImg[index].notFilledIn = false;
        } else {
          if (item.Score != 0) {
            this.doctorQCImg[index].notFilledIn = true;
          }
        }
      }
      if (this.gradeType == "history") {
        if (item.Note != "") {
          this.doctorQCHistory[index].notFilledIn = false;
        } else {
          if (item.Score != 0) {
            this.doctorQCHistory[index].notFilledIn = true;
          }
        }
      }
      this.$forceUpdate();
    },
    compentedScore(isSerious, objindex) {
      if (this.gradeType == "report") {
        let reportScore = 0;
        let setReportScore = 0;
        if (isSerious === true) {
          console.log(this.doctorQCReport);
          this.doctorQCReport[objindex].OptionGuid = [];
        } else if (isSerious === false) {
          this.doctorQCReport[objindex].Score = 500;
        }
        for (let i = 0; i < this.doctorQCReport.length; i++) {
          if (this.doctorQCReport[i].Score != 500) {
            this.doctorQCReport[i].notSelected = false;
          }
          if (this.doctorQCReport[i].IsSerious) {
            reportScore += this.doctorQCReport[i].SeriousScore;
            this.doctorQCReport[i].Score = this.doctorQCReport[i].SeriousScore;
          } else {
            reportScore += this.doctorQCReport[i].Score != 500 ? this.doctorQCReport[i].Score : 0;
          }

          //显示备注
          if (
            this.doctorQCReport[i].IsSerious ||
            (this.doctorQCReport[i].Score != 500 && this.doctorQCReport[i].Score != 0)
          ) {
            this.doctorQCReport[i].IsNoteShow = true;
          } else {
            this.doctorQCReport[i].IsNoteShow = false;
          }
        }
        setReportScore = 100 - reportScore > 0 ? 100 - reportScore : 0;

        if (setReportScore > 100) {
          setReportScore = 100;
        }
        this.setScoreTotile({
          type: "report",
          num: setReportScore,
        });
      }
      if (this.gradeType == "img") {
        let imgScore = 0; //扣分
        let setImgScore = 0;
        if (isSerious === true) {
          this.doctorQCImg[objindex].OptionGuid = [];
        } else if (isSerious === false) {
          this.doctorQCImg[objindex].Score = 500;
        }
        for (let i = 0; i < this.doctorQCImg.length; i++) {
          if (this.doctorQCImg[i].Score != 500) {
            this.doctorQCImg[i].notSelected = false;
          }

          if (this.doctorQCImg[i].IsSerious) {
            imgScore += this.doctorQCImg[i].SeriousScore;
            this.doctorQCImg[i].Score = this.doctorQCImg[i].SeriousScore;
          } else {
            imgScore += this.doctorQCImg[i].Score != 500 ? this.doctorQCImg[i].Score : 0;
          }

          //显示备注
          if (this.doctorQCImg[i].IsSerious || (this.doctorQCImg[i].Score != 500 && this.doctorQCImg[i].Score != 0)) {
            this.doctorQCImg[i].IsNoteShow = true;
          } else {
            this.doctorQCImg[i].IsNoteShow = false;
          }
        }
        setImgScore = 100 - imgScore > 0 ? 100 - imgScore : 0;

        if (setImgScore > 100) {
          setImgScore = 100;
        }
        this.setScoreTotile({
          type: "img",
          num: setImgScore,
        });
      }
      if (this.gradeType == "history") {
        let historyScore = 0; //扣分
        let setHistoryScore = 0;
        if (isSerious === true) {
          this.doctorQCHistory[objindex].OptionGuid = [];
        } else if (isSerious === false) {
          this.doctorQCHistory[objindex].Score = 500;
        }
        for (let i = 0; i < this.doctorQCHistory.length; i++) {
          if (this.doctorQCHistory[i].Score != 500) {
            this.doctorQCHistory[i].notSelected = false;
          }

          if (this.doctorQCHistory[i].IsSerious) {
            historyScore += this.doctorQCHistory[i].SeriousScore;
            this.doctorQCHistory[i].Score = this.doctorQCHistory[i].SeriousScore;
          } else {
            historyScore += this.doctorQCHistory[i].Score != 500 ? this.doctorQCHistory[i].Score : 0;
          }

          //显示备注
          if (this.doctorQCHistory[i].IsSerious || (this.doctorQCHistory[i].Score != 500 && this.doctorQCHistory[i].Score != 0)) {
            this.doctorQCHistory[i].IsNoteShow = true;
          } else {
            this.doctorQCHistory[i].IsNoteShow = false;
          }
        }
        setHistoryScore = 100 - historyScore > 0 ? 100 - historyScore : 0;

        if (setHistoryScore > 100) {
          setHistoryScore = 100;
        }
        this.setScoreTotile({
          type: "history",
          num: setHistoryScore,
        });
      }
    },
    computeItemScore(score, seriousScore, isSerious) {
      if (isSerious) {
        return seriousScore;
      } else {
        return score != 500 ? score : 0;
      }
    },
  },
};
</script>
